import styled from 'styled-components'
import { Spin } from 'antd'

export const VeritasSpinner = styled(Spin)`
    color: #7BAD7E;
    & .ant-spin-dot-item {
        background-color: #7BAD7E
    }
`
